<template>
	<section class="nor-data-list">
		<section class="news-nor-data" v-for="(item, index) in nordata" :key="index">
			<section class="news-nor-data-header">
				<span class="header-level type-news" :class="newsStates[item.type]">{{item.typeName}}</span>
				<time class="header-date">{{item.createDate | formatTime}}</time>
			</section>
			<section class="news-nor-data-main">
				<a :href="$i18n.path(`news/${item.id}`)" target="_blank">
					<h2 class="main-header">
						{{item.title}}
					</h2>
					<p class="main-des">
						{{item.content}}
					</p>
				</a>
			</section>
			<section class="news-nor-data-share">
				<span class="share-link" v-if='item.link'>
          <!-- TODO: 这玩意是啥？需不需要i18n？ -->
					<a :href="item.link">{{ $t('nor-news.top') }}:{{item.linkName}}</a>
				</span>
				<span class="share-icon">
					<!-- <share :NewId='data.id' :title='data.title' :summary='data.content'></share> -->
				</span>
			</section>
		</section>
		<a class="more-button" @click='getMoreNews'>{{ $t('nor-news.more') }}</a>
	</section>
</template>

<script>
	// import { parseTime } from '~/plugins/filters'
	import allStates from '~/plugins/allStates'
  export default {
    props: ['nordata'],
		data() {
			return {
			}
		},
		filters: {
			// filters(str){
			// 	return parseTime(str)
			// }
		},
		created() {
      this.newsStates = allStates.newsStates
    },
		methods: {
			getMoreNews() {
				this.$emit('getMoreNews')
			}
		}
  }
</script>

<style lang="less" scoped>
	.nor-data-list {
		width: 860px;
		padding-bottom: 20px;
		display: flex;
		flex-flow: row wrap;
		justify-content: space-between;
		.news-nor-data {
			height: 241px;
			width: 424px;
			padding: 20px;
			display: inline-block;
			overflow: hidden;
			border: 1px solid #e8e8e8;
			margin-top: 12px;
			border-radius: 4px;
			background: #ffffff;
			.news-nor-data-header {
				.header-date {
					color: #838d97;
					font-size: 12px;
					padding: 0 10px;
				}
				.header-level {
					display: inline-block;
					font-size: 14px;
					line-height: 28px;
					height: 28px;
					width: 91px;
					color: white;
					text-align: center;
					border-radius: 14px;
				}
			}
			.news-nor-data-main {
				a {
					font-size:16px;
					color:#333;
					.main-header {
						font-weight: bolder;
						padding: 20px 0;
						line-height: 1.3;
						height: 88px;
						overflow: hidden;
						&:hover {
							color: #3278d2
						}
					}
					.main-des {
						font-size: 14px;
						color: #838d97;
						line-height: 1.5;
						overflow: hidden;
						text-overflow: ellipsis;
						height: 38px;
						&:hover {
							color: #333
						}
					}
				}
			}
			.news-nor-data-share {
				font-size: 12px;
				padding: 30px 0;
				overflow: hidden;
				clear: both;
				_zoom: 1;
				.share-icon {
					float: right;
				}
				.share-link a {
					color: #3175d1;
					line-height: 21px;
					height: 21px;
					display: inline-block;
					max-width: 250px;
					overflow: hidden;
				}
			}
			.type-news {
				background: #e45d5b
			}

			.type-unusal {
				background: #ca5ba0
			}

			.type-level {
				background: #63c7dd
			}

			.type-summary {
				background: #559ae2
			}

			.type-event {
				background: #e31818
			}
		}
		.more-button {
			margin-top: 20px;
			cursor:pointer;
		}
	}
</style>
